<template>
    <main class="secondary-menu">
        <div class="bg-white border-top">
            <horizontal-scroll class="container" buttons-class="shadow-none">
                <div class="d-flex flex-nowrap">
                    <ul class="nav secondary-nav alternate position-relative align-items-center flex-nowrap mr-auto">
                        <template v-for="item in services">
                            <li v-if="item.route !== '#'" class="nav-item" :key="item.name">
                                <router-link
                                    :to="item.route"
                                    :title="item.name" class="nav-link px-1"
                                    active-class="active text-primary font-weight-bold">
                                    <img v-if="item.icon" :src="item.icon"
                                         height="14" class="mr-2" alt="">
                                    <i v-if="item.faIcon" :class="item.faIcon"></i>
                                    {{ item.name }}
                                </router-link>
                            </li>
                            <li class="nav-item px-3">
                                <div class="bg-light-3" style="width: 2px; height: 26px"></div>
                            </li>
                        </template>
                    </ul>
                </div>
            </horizontal-scroll>
        </div>
        <router-view></router-view>
    </main>
</template>

<script>
import {appDataMixin} from "../../core/data/global";
import HorizontalScroll from "../core/horizontal-scroll.vue";

export default {
    name: 'BillsHome',
    components: {HorizontalScroll, Dropdown: () => import("../core/dropdown.vue")},
    mixins: [appDataMixin],
    mounted() {
        let uri = window.location.search.substring(1);
        let params = new URLSearchParams(uri);
        let context = params.get('context');
        if (context) {
            if (context === "stripe-batch") {
                let ref = params.get('ref');
                if (ref) {
                    this.$router.push(`/business/stripe?ref=${ref}`);
                }
            }

            if (context === "stripe") {
                let id = params.get('id');
                let type = params.get('type');

                if (id && type) {
                    if (type === "zesa") {
                        this.$router.push(`/zesa/stripe?id=${id}`);
                    }

                    if (type === "airtime") {
                        this.$router.push(`/airtime/stripe?id=${id}`);
                    }

                    if (type === "bundles") {
                        this.$router.push(`/bundles/stripe?id=${id}`);
                    }

                    if (type === "telone") {
                        this.$router.push(`/telone/stripe?id=${id}`);
                    }

                    if (type === "ticket-purchase"){
                        this.$router.push(`/tickets/stripe?id=${id}`);
                    }

                    if (type === "biller-payment")
                    {
                        this.$router.push(`/billers/stripe?id=${id}`);
                    }
                }
            }
        }
    },
}
</script>

<style>
.dropdown.nav-item span {
    margin-bottom: 0 !important;
}
</style>
